import { FormikContextType } from 'formik';
import { TDocSeries } from 'shared/constants/docs';
import { FormTextField } from 'shared/_ui/form/form-text-field';
import { FormTagField } from 'shared/_ui/form/form-tag-field';
import { FormSelectField } from 'shared/_ui/form/form-select-field';
import SwitchField from 'shared/_ui/form/switch-field';
import { MenuItem } from '@mui/material';
import { useEditDocumentContext } from 'shared/hooks/use-edit-document';
import { SERIES_TYPE_IDS, SERIES_TYPES } from 'shared/constants/pouchDB';
import { CATEGORIES } from 'shared/utils/youtube';
import { useUserContext } from 'shared/Providers/User';

const LABEL_WIDTH = '8.5rem';

export default function SeriesMetadata({ formik }: { formik: FormikContextType<TDocSeries> }) {
	const { isEdit } = useEditDocumentContext();
	const {
		permissions: { canPublishMedia },
	} = useUserContext();

	const isVideoType = formik.values.seriesType === SERIES_TYPE_IDS.video;
	const seriesTypeOptions = formik.values.seriesType
		? [formik.values.seriesType]
		: (Object.keys(SERIES_TYPES) as string[]);

	return (
		<>
			<FormTextField
				label="Title:"
				name="title"
				fullWidth
				formik={formik}
				labelProps={{ width: LABEL_WIDTH }}
				spellCheck
				readOnly={!isEdit}
			/>
			<FormTextField
				label="Description:"
				name="description"
				fullWidth
				formik={formik}
				labelProps={{ width: LABEL_WIDTH }}
				multiline
				spellCheck
				readOnly={!isEdit}
			/>
			<FormTagField
				label="Keywords:"
				name="keywords"
				fullWidth
				formik={formik}
				labelProps={{ width: LABEL_WIDTH }}
				readOnly={!isEdit}
			/>
			<FormSelectField
				label="Type:"
				name="seriesType"
				fullWidth
				formik={formik}
				labelProps={{ width: LABEL_WIDTH }}
				readOnly={!isEdit || !!formik.values.seriesType}
			>
				{seriesTypeOptions.map((typeId) => (
					<MenuItem key={typeId} value={typeId}>
						{(SERIES_TYPES as any)[typeId]?.title || typeId}
					</MenuItem>
				))}
			</FormSelectField>
			{canPublishMedia && isVideoType && (
				<FormSelectField
					label="Youtube category:"
					name="youtube.categoryId"
					fullWidth
					formik={formik}
					labelProps={{ width: LABEL_WIDTH }}
					readOnly={!isEdit}
				>
					{(CATEGORIES as { id: number; title: string }[]).map((cat) => (
						<MenuItem key={cat.id} value={cat.id}>
							{cat.title}
						</MenuItem>
					))}
				</FormSelectField>
			)}
			{canPublishMedia && isVideoType && (
				<FormTextField
					label="Youtube channel Id:"
					name="youtube.channelId"
					fullWidth
					formik={formik}
					labelProps={{ width: LABEL_WIDTH }}
					readOnly={!isEdit}
				/>
			)}
			{isEdit && (
				<SwitchField
					label="Show seasons:"
					name="seasons"
					formik={formik}
					labelProps={{ width: LABEL_WIDTH }}
				/>
			)}
		</>
	);
}
